// 闭环报送
export default [
  {
    path: '/closedLoopSubmitted',
    component: resolve => require(['@/pages/closedLoopSubmitted/closedLoopSubmitted.vue'], resolve),
    name: 'closedLoopSubmitted',
    meta: {
      title: '闭环报送'
    }
  },
  {
    path: '/closedLoopStatistics',
    component: resolve => require(['@/pages/closedLoopSubmitted/closedLoopReportingStatistics.vue'], resolve),
    name: 'closedLoopReportingStatistics',
    meta: {
      title: '闭环报送统计'
    }
  },
  {
    path: '/securityInformationOfficer',
    component: resolve => require(['@/pages/closedLoopSubmitted/securityInformationOfficer.vue'], resolve),
    name: 'closedLoopReportingStatistics',
    meta: {
      title: '安全信息员'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/closedLoopSubmitted.js